module.exports = __webpack_public_path__ + "assets/img/hand.6e1092b7.png";